import { phone, email, pdfCommissions, pdfLevels } from '@/config'

const contacts = {
  whatsapp1: '23409060417560',
  whatsapp2: '23409037736063'
}

const referralLink = 'https://aal4.adj.st/?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Fng%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.com.ng%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral'

const dashboardGetUpdatedItems = [
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.media.facebook_group'
    },
    link: 'https://www.facebook.com/groups/127012364628275/',
    newPage: true
  },
  {
    img: 'img/dashboard/blog.svg',
    title: {
      key: 'dashboard.media.jumia_blog'
    },
    link: 'https://blog.jumia.com.ng/',
    newPage: true
  },
  {
    disabled: true,
    img: 'img/dashboard/comingSoon.svg',
    title: {
      key: 'dashboard.media.jforce_blog'
    },
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
  {
    img: 'img/dashboard/whatsapp.svg',
    title: {
      text: 'Contact us via Whatsapp',
    },
    subtitle: {
      text: '704 067 2181',
      isKey: false
    },
    link: 'https://wa.me/2347040672181',
    newPage: true
  },
  {
    img: 'img/dashboard/contact-form.svg',
    title: {
      key: 'dashboard.claim_form.title'
    },
    subtitle: {
      text: 'through this claim form',
      isKey: false
    },
    link: 'https://docs.google.com/forms/d/1trxA81uEWDIxDyAM2UzvzBS5eMabfWmAEGd4n0TcXls/edit',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-telegram.svg',
    title: {
      text: 'Join us on Telegram'
    },
    link: 'https://t.me/+UEMFZu2WgddkYzA0',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      text: 'Join us on Facebook'
    },
    link: 'https://www.facebook.com/jforcenigeria',
    newPage: true
  },
]

const dashboardOtherItems = [
  {
    disabled: false,
    img: 'img/dashboard/faqs.svg',
    title: {
      key: 'dashboard.other.faq'
    },
    newPage: false,
    internalResource: true,
    link: 'jforce_faqs'
  },
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },
  {
    img: 'img/dashboard/commissionGrid.svg',
    title: {
      key: 'dashboard.other.commission_grid'
    },
    link: pdfCommissions,
    newPage: true
  },
  {
    img: 'img/dashboard/medal.svg',
    title: {
      key: 'dashboard.other.levels'
    },
    link: pdfLevels,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      text: 'Training'
    },
    link: 'https://www.youtube.com/playlist?list=PL4lpVav36HlqEoc_vLrBaz38zTUQ2f7P4',
    newPage: true
  }
]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
